

    function processProducts() {
        var groupId = getShoptetDataLayer('customer')?.groupId;
        if (!groupId || !ids.includes(groupId)) {
            return;
        }

        var codes = [];

        $('.product').each(function () {
            var sku = $(this).find('span[data-micro="sku"]').text().trim();
            if (sku) {
                codes.push(sku);
            }
        });

        if (codes.length === 0) {
            return;
        }

        $.ajax({
            url: 'https://php.shopcode.cz/variant-buy/api-products.php',
            method: 'GET',
            data: {
                shop_id: 'siruparna',
                code: codes.join(',')
            },
            dataType: 'json',
            success: function (response) {
                const priceListId = getShoptetDataLayer('customer')?.priceListId ?? null;

                response.forEach(function (productData) {
                    const productEl = $('.product').filter(function () {
                        return $(this).find('span[data-micro="sku"]').text().trim() === productData.code;
                    });

                    if (!productEl.length) return;
                    if (productData.variantVisibility !== "1") return;
                    productEl.closest('.product').find('.custom-product-data').remove();
                    const productStock = productData.negativeAmount === "1" ? 9999 : (productData.stock?.total ?? 0);

                    let finalPrice = productData.price;
                    if (
                        priceListId &&
                        productData.pricelists &&
                        productData.pricelists[priceListId] &&
                        productData.pricelists[priceListId].price
                    ) {
                        finalPrice = productData.pricelists[priceListId].price;
                    }

                    let html = `
                        <div class="custom-product-data">
                            <div class="custom-friends">
                                <div class="variant" data-code="${productData.code}" data-stock="${productStock}">
                                    <div class="inner">
                                        <span class="title">${productData.variant_name ?? ''}</span>
                                        <span class="price">${Number(finalPrice.replace(',', '.')).ShoptetFormatAsCurrency() ?? ''}</span>
                                    </div>
                                </div>
                    `;

                    if (productData.friends && productData.friends.length > 0) {
                        productData.friends.forEach(function (friend) {
                            if (friend.variantVisibility !== "1") return;

                            const friendStock = friend.negativeAmount === "1" ? 9999 : (friend.stock?.total ?? 0);

                            let friendPrice = friend.price;
                            if (
                                priceListId &&
                                friend.pricelists &&
                                friend.pricelists[priceListId] &&
                                friend.pricelists[priceListId].price
                            ) {
                                friendPrice = friend.pricelists[priceListId].price;
                            }

                            html += `
                                <div class="variant" data-code="${friend.code}" data-stock="${friendStock}">
                                    <div class="inner">
                                        <span class="title">${friend.variant_name ?? ''}</span>
                                        <span class="price">${Number(friendPrice.replace(',', '.')).ShoptetFormatAsCurrency() ?? ''}</span>
                                    </div>
                                </div>
                            `;
                        });
                    }
                    html += `</div></div>`;
                    productEl.closest('.product').find('.p-bottom>div').prepend(html);
                    productEl.closest('.product').addClass('haveVariant');
                });
            },
            error: function (xhr, status, error) {
                console.error('Chyba při načítání dat z API:', error);
            }
        });
    }

    $(document).ready(function () {
        processProducts();
    });

    document.addEventListener('ShoptetDOMPageContentLoaded', function () {
        processProducts();
    });
    document.addEventListener('ShoptetPageSortingChanged', function () {
        processProducts();
    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
        processProducts();
    });

    $('html').on('click', '.custom-friends .variant .inner', function(){
        var variantCode = $(this).closest('.variant').attr('data-code');
        var variantStock = $(this).closest('.variant').attr('data-stock');
        $('.product .customQuantity').remove();
        $('.custom-friends .variant').removeClass('activeVariant');
        $(this).closest('.variant').addClass('activeVariant');
        $(this).closest('.product').find('.p-bottom>div').prepend(`
            <div class="customQuantity">
            <span class="quantity">
                <span class="increase-tooltip js-increase-tooltip" data-trigger="manual" data-container="body" data-original-title="Není možné zakoupit více než ${variantStock} ks." aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
                <span class="decrease-tooltip js-decrease-tooltip" data-trigger="manual" data-container="body" data-original-title="Minimální množství, které lze zakoupit, je 1 ks." aria-hidden="true" role="tooltip" data-testid="tooltip"></span>
                    <label>
                        <input type="number" name="amount" value="1" class="amount" autocomplete="off" data-decimals="0" step="1" min="1" max="${variantStock}" aria-label="Množství" data-testid="cartAmount">
                    </label>
                <button class="increase" type="button" aria-label="Zvýšit množství o 1" data-testid="increase"><span class="increase__sign">+</span></button>
                <button class="decrease" type="button" aria-label="Snížit množství o 1" data-testid="decrease"><span class="decrease__sign">−</span></button>
            </span> 
            <span class="superButton btn btn-cart" data-code="${variantCode}">Do košíku</span>
            </div>
        `);
        initTooltips();
    });

    $('html').on('click', '.superButton', function(){
        var buyCode = $(this).data('code');
        var buyQuantity = $(this).closest('.customQuantity').find('.quantity input[type="number"]').val();
        shoptet.cartShared.addToCart({productCode: buyCode, amount: buyQuantity});
    });

